import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position when the route changes. With a single page this never
 * mattered; across six routes it is the difference between landing at the top
 * of a page and landing halfway down it.
 *
 * In-page anchor navigation (`#pricing`) is left alone.
 */
export function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}